import { render } from "./accounting.vue?vue&type=template&id=a771c64e&scoped=true"
import script from "./accounting.vue?vue&type=script&lang=js"
export * from "./accounting.vue?vue&type=script&lang=js"

import "./accounting.vue?vue&type=style&index=0&id=a771c64e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a771c64e"]])

export default __exports__